export default __webpack_public_path__ + "static/media/user_interface.92edf7ad.svg";